import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const Title = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);

  return (
    <Stack
      gap='16px'
      sx={{
        mb: isDesktop ? '8px' : '4px',
        textAlign: isDesktop ? undefined : 'center',
      }}
    >
      <Typography variant={isDesktop ? 'h3' : 'h2'}>
        {dictionary.title}
      </Typography>
      <Typography variant={isDesktop ? 'h4' : 'h3'} mt={isDesktop ? 4 : 1}>
        {dictionary.subtitle}
      </Typography>
    </Stack>
  );
};
